import type { DemoScript } from "../types";
import { CREATORS_SCRIPT_COPY } from "./creators-script.copy";

/**
 * Roteiro da tela Creators. Só roda em modo Collab — a aba não existe em conta
 * de creator, igual ao link do menu.
 */
export const buildCreatorsScript = (): DemoScript => [
  {
    id: "creators-intro",
    narrative: CREATORS_SCRIPT_COPY.creatorsIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "creators-summary",
    narrative: CREATORS_SCRIPT_COPY.creatorsSummary.narrative,
    zoomTargetId: "creators-summary",
    disableZoom: true,
    callout: {
      targetId: "creators-summary",
      text: CREATORS_SCRIPT_COPY.creatorsSummary.callout,
    },
    durationMs: 5400,
  },
  {
    id: "creators-overview",
    narrative: CREATORS_SCRIPT_COPY.creatorsOverview.narrative,
    durationMs: 1800,
  },
  {
    id: "creators-grid",
    narrative: CREATORS_SCRIPT_COPY.creatorsGrid.narrative,
    zoomTargetId: "creators-grid",
    callout: {
      targetId: "creators-grid",
      text: CREATORS_SCRIPT_COPY.creatorsGrid.callout,
    },
    durationMs: 5800,
  },
  {
    id: "creators-invite",
    narrative: CREATORS_SCRIPT_COPY.creatorsInvite.narrative,
    zoomTargetId: "creators-grid",
    callout: {
      targetId: "creators-grid",
      text: CREATORS_SCRIPT_COPY.creatorsInvite.callout,
    },
    durationMs: 5000,
  },
];
